import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  status: string;
  chapters: number;
  tags: string[];
  updateDate: string;
  featured?: boolean;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  status,
  chapters,
  tags,
  updateDate,
  featured,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) {
      return `${(v / 10000).toFixed(1)}万`;
    }
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${id}`}
      className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden aspect-[3/4]">
        <img
          src={cover}
          alt={`${title} - 韩漫在线阅读`}
          title={`${title} - 皮皮漫画网免费韩国漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {featured && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            推荐
          </span>
        )}
        <div className="absolute top-2 right-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
          {status}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3 pt-8">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 line-clamp-1">{author}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-0.5 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {formatViews(views)}
          </span>
          <span className="whitespace-nowrap">共{chapters}话</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="text-[10px] text-foreground-400 mt-2 whitespace-nowrap">更新于 {updateDate}</p>
      </div>
    </Link>
  );
}